export default {
  INITIATED: 'initiated',
  PAID: 'paid',
  CANCELLED: 'cancelled',
  STOPPED: 'stopped',
};



// WEBPACK FOOTER //
// ./src/variables/ski/school/status-type-enums.js